import React, { useEffect, useState } from "react";
import IndustryChart from "./chart";
import { backgroundColors } from "./utils/backgroundColors";
import styles from "./style.module.scss";
import useDashboardStore, {
  fetchIndustriesData,
} from "../../../../stores/dashboard";
import Spinner from "../../../../components/Loaders/Spinner";

const Industries = () => {
  const industriesData = useDashboardStore((s) => s.industriesData);
  const industriesDataLoading = useDashboardStore(
    (s) => s.industriesDataLoading,
  );

  const filterDataStartDate = useDashboardStore((s) => s.filterData.startDate);
  const filterDataEndDate = useDashboardStore((s) => s.filterData.endDate);
  const filterUser = useDashboardStore((s) => s.filterUser);
  const filterOrg = useDashboardStore((s) => s.filterOrg);

  useEffect(() => {
    const abortController = new AbortController();
    fetchIndustriesData(abortController);

    return () => {
      abortController.abort();
    };
  }, [filterDataStartDate, filterDataEndDate, filterUser, filterOrg]);

  return (
    <div className={styles.industries}>
      <div className={styles.industriesHeader}>
        <p className={styles.industriesHeaderTitle}>Industries (MCC)</p>
        <p className={styles.industriesHeaderSubtitle}>
          {filterDataStartDate} - {filterDataEndDate}
        </p>
      </div>

      {industriesDataLoading && (
        <div className={styles.industriesContentLoading}>
          <Spinner />
        </div>
      )}

      {!industriesDataLoading && (
        <>
          {industriesData.length > 0 ? (
            <>
              <div className={styles.industriesContent}>
                <IndustryChart data={industriesData} />
              </div>

              <div className={styles.industriesFooter}>
                {!industriesDataLoading &&
                  industriesData &&
                  industriesData.length > 0 &&
                  industriesData.map((item, index) => (
                    <div className={styles.industriesFooterItem} key={item.mcc}>
                      <span
                        className={styles.colorDot}
                        style={{ backgroundColor: backgroundColors[index] }}
                      ></span>
                      <span className={styles.industryName}>{item.mcc}</span>
                    </div>
                  ))}
              </div>
            </>
          ) : (
            <div className={styles.emptyContainer} >
              <div className={styles.iconBox} >
                <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
                  <path d="M16.125 18.1922C16.3151 18.0825 16.4729 17.9246 16.5826 17.7345C16.6923 17.5445 16.75 17.3288 16.75 17.1094V5.85938C16.7489 5.66009 16.7001 5.46395 16.6078 5.28733C16.5155 5.11071 16.3823 4.95872 16.2193 4.84405C16.0563 4.72937 15.8682 4.65533 15.6708 4.6281C15.4734 4.60086 15.2723 4.62123 15.0844 4.6875C11.4359 5.97877 8.36767 8.52913 6.43126 11.8801C4.49485 15.2311 3.81726 19.1629 4.5203 22.9688C4.55674 23.1656 4.63991 23.3507 4.76281 23.5087C4.88571 23.6667 5.04475 23.7928 5.22655 23.8766C5.39038 23.9532 5.56912 23.9927 5.74998 23.9922C5.96938 23.9923 6.18493 23.9346 6.37498 23.825L16.125 18.1922ZM14.25 7.75312V16.3875L6.76873 20.7047C6.74998 20.4688 6.74998 20.2313 6.74998 20C6.7522 17.4662 7.45357 14.9821 8.77685 12.8213C10.1001 10.6605 11.994 8.90674 14.25 7.75312ZM20.5 3.75C20.1685 3.75 19.8505 3.8817 19.6161 4.11612C19.3817 4.35054 19.25 4.66848 19.25 5V19.3469L6.93592 26.5203C6.79303 26.6031 6.66796 26.7135 6.56796 26.8449C6.46796 26.9764 6.395 27.1264 6.3533 27.2862C6.31161 27.446 6.30199 27.6125 6.32503 27.7761C6.34806 27.9396 6.40327 28.097 6.48748 28.2391C7.93077 30.6927 9.99328 32.7241 12.4685 34.1299C14.9437 35.5358 17.7449 36.2668 20.5914 36.2497C23.438 36.2326 26.2301 35.4681 28.6883 34.0326C31.1465 32.5972 33.1845 30.5411 34.5982 28.0704C36.012 25.5997 36.7519 22.8009 36.7439 19.9543C36.7359 17.1077 35.9802 14.3131 34.5526 11.8504C33.125 9.38762 31.0754 7.3431 28.6092 5.92149C26.143 4.49988 23.3466 3.75106 20.5 3.75ZM20.5 33.75C18.3179 33.7442 16.1681 33.2218 14.2266 32.2257C12.2852 31.2295 10.6071 29.7879 9.32967 28.0188L21.1297 21.1438C21.3195 21.0341 21.4772 20.8766 21.5869 20.6868C21.6966 20.497 21.7544 20.2817 21.7547 20.0625V6.30625C25.2803 6.62612 28.5468 8.29351 30.8739 10.9613C33.2011 13.629 34.4096 17.0915 34.2479 20.628C34.0862 24.1644 32.5668 27.5022 30.0059 29.9465C27.4451 32.3908 24.0401 33.7532 20.5 33.75Z" fill="#A4A3A8" />
                </svg>
              </div>

              <p className={styles.emptyTitle} >
                This chart will display the sales volume and number of MIDs by industry (MCC)
              </p>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Industries;
